import { SaveToCloudStatus } from 'owa-attachment-savetocloud';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import { ImageGalleryItem } from 'owa-sxsdata';
import { action } from 'satcheljs';
import { EditMode } from '../store/schema/SxSEditState';

export const onEditModeChange = action(
    'onEditModeChange',
    (mode: EditMode, itemId: ClientItemId) => ({
        mode,
        itemId,
    })
);

export const onImageGalleryItemUpdatePreviewUrl = action(
    'onImageGalleryItemUpdatePreviewUrl',
    (imageGalleryItem: ImageGalleryItem, previewUrl: string) => ({
        imageGalleryItem,
        previewUrl,
    })
);

export const onAttachmentIdUpdate = action(
    'onAttachmentIdUpdate',
    (attachmentId: ClientAttachmentId) => ({
        attachmentId,
    })
);

export const internalCloseSxS = action('internalCloseSxS');

export const setSaveToCloudStatus = action(
    'setSaveToCloudStatus',
    (saveToCloudStatus: SaveToCloudStatus, attachmentId: ClientAttachmentId) => ({
        saveToCloudStatus,
        attachmentId,
    })
);

export const onComposeStateChange = action('onComposeStateChange', (composeViewState: any) => ({
    composeViewState,
}));

export const onInvisibilityChange = action('onInvisibilityChange', (invisible: boolean) => ({
    invisible,
}));

export const onShouldUseFakeRightHandSideChange = action(
    'onShouldUseFakeRightHandSideChange',
    (shouldUseFakeRightHandSide: boolean) => ({
        shouldUseFakeRightHandSide,
    })
);

export const onUsingFakeRightHandSideChange = action(
    'onUsingFakeRightHandSideChange',
    (isUsingFakeRightHandSide: boolean) => ({
        isUsingFakeRightHandSide,
    })
);

export const onShouldHideReadingPaneOutsideSxSChange = action(
    'onShouldHideReadingPaneOutsideSxSChange',
    (shouldHideReadingPaneOutsideSxS: boolean) => ({
        shouldHideReadingPaneOutsideSxS,
    })
);
